import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router'
import { ErrorBoundary, addReactError } from '@datadog/browser-rum-react'
// ideon-ui ships no stylesheet, so the app self-hosts the fonts its preset's
// fontFamily stacks name. Weight set matches ideon-ui's own Storybook
// (.storybook/preview.ts): Inter 400-800 (+ 400/600 italic), Manrope 600/700.
import '@fontsource/inter/400.css'
import '@fontsource/inter/400-italic.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/600-italic.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'
import '@fontsource/manrope/600.css'
import '@fontsource/manrope/700.css'
import './css/tailwind.css'
import ddRum from './lib/datadogRum'
import Howie from './components/Howie'
import Auth0Bootstrap from './components/Auth0/Auth0Bootstrap'
import store from './store'
import ErrorBoundaryFallback from './components/common/ErrorBoundary'
import { basename } from './routerHistory'

ddRum.init({
  applicationId: '636f8c94-2081-4a8c-b3f0-646bc8c1c355',
  clientToken: 'pub340c206cceacf80e53e85efe4d8b9fbd',
  site: 'datadoghq.com',
  service: 'howie',
  env: process.env.DD_ENV || 'development',

  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'mask-user-input',
  trackViewsManually: true
})

const root = ReactDOM.createRoot(document.getElementById('root'), {
  onUncaughtError: (error, errorInfo) => {
    if (ddRum.isEnabled()) addReactError(error, errorInfo)
  }
})

root.render(
  <Provider store={store}>
    <BrowserRouter basename={basename}>
      <ErrorBoundary fallback={ErrorBoundaryFallback}>
        <Auth0Bootstrap>
          <Howie />
        </Auth0Bootstrap>
      </ErrorBoundary>
    </BrowserRouter>
  </Provider>
)

